// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1U0EG","title":"Images45_title__2Orcn","images":"Images45_images__1FQ8V"};